import { Link } from 'react-router-dom'
import { cn } from '../../../lib/cn'
import { dataSimples } from '../../../lib/datas'
import { reais } from '../../../lib/dinheiro'
import type { ResumoDaOs } from '../../../types/ordemDeServico'
import { SeloDaSituacao } from '../SeloDaSituacao'
import { OS } from '../textosDaOs'
import { mesDaOs, periodoDaOs } from './colunasDaOs'

/**
 * A mesma ordem, no telefone.
 *
 * Cartão e não tabela rolando de lado: fiscal de contrato confere pelo celular, e sete colunas em
 * 360px viram uma faixa que se arrasta com o dedo — quem lê a primeira coluna nunca chega na
 * situação, que é a informação que ele foi buscar. A troca é por CSS na página, nunca por
 * `matchMedia`.
 *
 * O cartão inteiro é UM link, e não uma caixa clicável com link dentro: o alvo de toque é o cartão
 * todo, o leitor de tela anuncia um destino só e o "abrir em nova aba" continua funcionando. Por
 * isso nada aqui dentro pode virar botão.
 *
 * @param props a linha da listagem
 * @returns o cartão
 */
export function CartaoDeOs({ ordem }: { ordem: ResumoDaOs }) {
  return (
    <li>
      <Link
        to={`/ordens-servico/${ordem.id}`}
        className={cn(
          'block rounded-xl border p-4 shadow-cartao transition-colors',
          'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-niteroi-600',
          ordem.revogada
            ? 'border-slate-300 border-l-4 border-l-slate-400 bg-slate-100'
            : 'border-slate-200 bg-white hover:border-niteroi-200 hover:bg-niteroi-50',
        )}
      >
        <div className="flex items-start justify-between gap-2">
          <span className="min-w-0">
            <span className="block font-semibold tabular-nums text-niteroi-700">{ordem.numero}</span>
            {ordem.numeroExterno && <span className="block text-xs text-slate-500">{ordem.numeroExterno}</span>}
          </span>
          <time dateTime={ordem.emitidaEm} className="whitespace-nowrap text-xs tabular-nums text-slate-500">
            {dataSimples(ordem.emitidaEm)}
          </time>
        </div>

        <div className="mt-3">
          <SeloDaSituacao situacao={ordem.situacao} comEspera />
        </div>

        <dl className="mt-3 grid grid-cols-[auto,1fr] gap-x-3 gap-y-1 text-sm">
          <dt className="text-slate-500">Modelo</dt>
          <dd className="min-w-0 text-slate-800">{OS.regimes[ordem.regime]}</dd>
          <dt className="text-slate-500">{OS.competencia}</dt>
          <dd className="min-w-0 tabular-nums text-slate-800">{mesDaOs(ordem)}</dd>
          <dt className="text-slate-500">{OS.periodo}</dt>
          <dd className="min-w-0 tabular-nums text-slate-800">{periodoDaOs(ordem)}</dd>
          <dt className="text-slate-500">{OS.valor}</dt>
          <dd className="min-w-0 tabular-nums text-slate-800">{reais(ordem.valorTotal)}</dd>
        </dl>
      </Link>
    </li>
  )
}
